/**
 * HeaderPostsSection
 */

import './styles.scss';

import * as React from 'react';

import ScrollableSection, { ScrollableSectionProps } from '../ScrollableSection';
import HeaderPost from './HeaderPost';

interface IHeaderPostsSection {
  new(): ScrollableSection<GQL.IHomePagePost>;
}
const HeaderPostsSection = ScrollableSection as IHeaderPostsSection;

export default function HeaderPosts(props: Pick<ScrollableSectionProps<GQL.IHomePagePost>, 'data'>) {
  return (
    <HeaderPostsSection
      id="header-posts"
      {...props}
    >{(item, index) => item ? <HeaderPost data={item} index={index} /> : null}
    </HeaderPostsSection>
  );
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/organisms/content/HeaderPosts/index.tsx